import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
/**
 * Classe criada para compartilhamento de propriedades entre componentes
 */
export class StatesService {

  /**
   * Propriedade criada para controlar o filtro de datas que será usado para mudar dados nas telas que tiverem essa necessidade
   */
  private dateSetup = new BehaviorSubject<any>(
    {
      start_date : moment(new Date()).startOf('day').toDate(),
      end_date: moment(new Date()).endOf('day').toDate()
    }
  );
  /**
   * Propriedade que será utilizada para filtro de data
   */
  currentDate = this.dateSetup.asObservable();
  /**
   * Propriedade criada para monitorar o selecionado no filtro
   */
  private selected = new BehaviorSubject<number>(0);
  /**
   * Propriedade utilizada na selecao do filtro
   */
  currentSelected = this.selected.asObservable();
  /**
   * Propriedade criada para controlar os dados de pedidos cross component
   */
  private orders = new BehaviorSubject<any>(null);
  /**
   * Propriedade que será utilizada para carregar produtos
   */
  currentOrders = this.orders.asObservable();
  /**
   * Propriedade criada para controlar os dados de seis ordens cross component
   */
  private sixOrders = new BehaviorSubject<any>(null);
  /**
   * Propriedade que será utilizada para carregar seis ordens
   */
  currentSixOrders = this.sixOrders.asObservable();
  /**
   * Propriedade criada para controlar os dados de rupturas cross component
   */
  private ruptures = new BehaviorSubject<any>(null);
  /**
   * Propriedade que será utilizada para carregar rupturas
   */
  currentRuptures = this.ruptures.asObservable();

   /**
   * Propriedade criada para controlar os dados de rupturas cross component
   */
  private metas = new BehaviorSubject<any>(null);
  /**
   * Propriedade que será utilizada para carregar rupturas
   */
  currentMetas = this.metas.asObservable();
   
  /**
   * Propriedade criada para controlar os dados de avaliacao cross component
   */
  private evaluations = new BehaviorSubject<any>(null);
  /**
   * Propriedade que será utilizada para carregar avaliacoes
   */
  currentEvaluations = this.evaluations.asObservable();

  constructor() { }

  /**
   * Funcao criada para alterar o valor das datas passadas pelo filtro
   * @param dates Propriedade que recebe as datas
   */
  changeDate(dates: any) {
    this.dateSetup.next(dates);
  }
  /**
   * Funcao criada para alterar o valor da selecao dos filtros
   * @param sel Propriedade que recebe numero da selecao
   */
  changeSelected(sel: number) {
    this.selected.next(sel);
  }
  /**
   * Funcao criada para alterar o valor dos pedidos quando usar filtro
   * @param ord Propriedade que recebe os pedidos
   */
  changeOrder(ord: any){
    this.orders.next(ord);
  }
  /**
   * Funcao criada para alterar o valor das ultimas 6 ordens quando usar filtro
   * @param ord Propriedade que recebe as ordens
   */
  changeRecentSixOrders(ord: any){
    this.sixOrders.next(ord);
  }
  /**
   * Funcao criada para alterar o valor de rupturas quando usar filtro
   * @param rup Propriedade que recebe as rupturas
   */
  changeRupturs(rup: any){
    this.ruptures.next(rup);
  }

    /**
   * Funcao criada para alterar o valor de rupturas quando usar filtro
   * @param rup Propriedade que recebe as rupturas
   */
  changeMetas(rup: any){
    this.metas.next(rup);
  }
  /**
   * Funcao criada para alterar o valor das avaliacoes quando usar filtro
   * @param eva Propriedade que recebe as avaliacoes
   */
  changeEvaluations(eva: any){
    this.evaluations.next(eva);
  }
}
